export default __webpack_public_path__ + "static/Markus.Gudmundsson_social-1ea8b62cbe12f2942c234c45a859811b.jpg";